export default __webpack_public_path__ + "static/media/fun_apr2020_pt1.d1b97196.bmp";